'use client';

import type { ReactElement } from 'react';
import { MindmapControlButtons } from './MindmapControlButtons';

interface MindmapSideColumnProps {
  isFocusDisabled: boolean;
  onCollapseAll: () => void;
  onExpandAll: () => void;
  onFocusTree: () => void;
}

export function MindmapSideColumn({
  isFocusDisabled,
  onCollapseAll,
  onExpandAll,
  onFocusTree,
}: MindmapSideColumnProps): ReactElement {
  return (
    <MindmapControlButtons
      isFocusDisabled={isFocusDisabled}
      onCollapseAll={onCollapseAll}
      onExpandAll={onExpandAll}
      onFocusTree={onFocusTree}
    />
  );
}
